import React, {Fragment, useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";

import axios from "axios";
import clientconfigwebapp, {
    check_login_appbk, empty_bk, Token_get_appbk,NewlineText_bk
} from "../../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";
import Grid from '@mui/material/Grid';
import {
    Icon_User,
    Icon_Location,
    Icon_inventory,
    Icon_Insurance,
    Icon_Packaging_and_label,
    Icon_Quality_Control,
    Icon_Transportation,
    Icon_Customs_formalities,
    Icon_singpro_Authenticated,
    Icon_btn_tiket_singprod,
    Icon_btn_call_singprod,
} from "../../../assets/icones/icones_single_products";
import Sticky from "react-stickynode";
import ProductCard from "../../../components/Card_boxs/ProductCard";


const Section_3 = (props) => {


    return (<Fragment>



        {
            props.posts_products_curent_cat && props.posts_products_curent_cat.length > 0 ? (

                    <div style={{"borderTop":"1px solid rgb(209, 213, 219)","paddingTop":"21px","paddingBottom":"10px","marginTop":"31px"}}>

                        <Fragment>

                            <span className={"title_section_desc_single_prod"}>محصولات مرتبط</span>


                            <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>
                                {


                                    props.posts_products_curent_cat.map((item_post, index) => {


                                        return (

                                            <Grid item lg={2.4} md={2.4} sm={12} xs={12}>
                                                <ProductCard link_to={"product/" + String(item_post.id_post)}
                                                             data_full_curent_item={item_post}/>
                                            </Grid>

                                        )

                                    })

                                }

                            </Grid>

                        </Fragment>
                    </div>


            ) : (
                <Fragment></Fragment>)

        }




    </Fragment>);
}

export default Section_3;
